/**
 * NavArrowLink — the NAVIGATION-LINK affordance (R1, brief of record
 * 2026-07-06): sage, trailing arrow, hover underline. Navigation reads
 * as a LINK, never a button — "does it show a place they could leave
 * without consequence? Link."
 */

import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

export interface NavArrowLinkProps {
  to: string;
  children: ReactNode;
  /** Hide the trailing arrow (inline prose links like "Add it"). */
  arrow?: boolean;
  className?: string;
  'data-testid'?: string;
}

export function NavArrowLink({
  to,
  children,
  arrow = true,
  className,
  ...rest
}: NavArrowLinkProps): ReactNode {
  return (
    <Link
      to={to}
      className={[
        'whitespace-nowrap text-[13px] font-semibold text-sage-800 no-underline',
        'border-b border-sage-300 pb-px hover:border-sage-800',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
      {arrow && <span aria-hidden="true"> {'→'}</span>}
    </Link>
  );
}
